<template>
  <v-card class="pa-3">
    <v-btn icon @click="$emit('close')" class="float-right">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-card-title>Report</v-card-title>
    <v-form v-model="isValid" ref="form">
      <v-select
        v-model="reason"
        :items="validReportReasons"
        label="Reason"
        :rules="[rules.required]"
        color="accent"
      ></v-select>
      <textarea placeholder="additional comments" rows="3" v-model="comments"></textarea>
      <div class="d-flex justify-end mt-5">
        <v-btn @click="submit" :disabled="!isValid" color="red darken-4" :dark="isValid">Report</v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import CookieTools from "../mixins/cookieTools";
import { mapMutations } from "vuex";
import { reportableContentTypes, freeTextReportReasons, userReportReasons } from "../util/enums";

export default {
  name: "report-form.vue",

  props: {
    contentId: [Number, String],
    type: {
      validator(value) {
        return value === undefined || Object.values(reportableContentTypes).includes(value);
      },
    },
  },

  computed: {
    validReportReasons() {
      switch (this.type) {
        case reportableContentTypes.USER:
          return userReportReasons;
        case reportableContentTypes.REVIEW:
        case reportableContentTypes.COMMENT:
          return freeTextReportReasons;
        default:
          throw new Error("unexpected contentType");
      }
    },
  },

  data: function () {
    return {
      isValid: false,
      reason: null,
      comments: null,

      rules: {
        required: (val) => !!val || "required",
      },
    };
  },

  mixins: [CookieTools],

  methods: {
    ...mapMutations(["showSnackbar"]),

    submit: function () {
      let payload = {
        item_id: this.contentId,
        reason: this.reason,
        type: this.type,
      };
      if (this.comments) payload.comments = this.comments;

      this.$axios
        .post("/report", payload)
        .then(() => {
          this.showSnackbar({
            text: "Report submitted",
          });

          this.reason = null;
          this.comments = null;
          this.isValid = false;
          this.$refs.form.reset();

          this.$emit("report");
        })
        .catch(() => {
          this.showSnackbar({
            text: "An error occurred",
            error: true,
          });
          this.$emit("error");
        });
    },
  },
};
</script>

<style scoped>
textarea {
  width: 100%;
  border: 1px solid gray;
  padding: 0 4px;

  border-radius: 5px;
}
textarea:focus {
  /* highlight color when focused */
  outline: 2px solid var(--v-accent-base);
}
</style>
